// Our entity list components require a height to be set in javascript,
// so we need to calculate based on headers, main content, and an optional
// footer how much height that actually is!
export function calculateMainContentHeight({
    headerHeight,
    headerOffset,
    footerHeight,
    pageContentHeight,
    hasNavbarOffset,
    hasTrialStatusBarOffset,
}: {
    headerHeight: number;
    headerOffset: number;
    footerHeight: number;
    pageContentHeight: number;
    hasNavbarOffset: boolean;
    hasTrialStatusBarOffset: boolean;
}) {
    return (
        pageContentHeight -
        headerHeight -
        headerOffset -
        footerHeight +
        (hasNavbarOffset ? 56 : 0) +
        (hasTrialStatusBarOffset ? 45 : 0)
    );
}
